import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "../../../providers/authProvider";
import { LoginForm } from "./LoginForm";
const DETAILER_CHECKER_ROLE_ID = 4;
const PROGRAMMER_ROLE_ID = 6;

const redirectTo = (location, route, roleId) => {
  const isDetailerChecker = roleId === DETAILER_CHECKER_ROLE_ID;
  const isProgrammer = roleId === PROGRAMMER_ROLE_ID;
  if (!isDetailerChecker && !isProgrammer && location.search) {
    const params = new URLSearchParams(location.search);
    return <Navigate to={params.get("returnURL")} />;
  }
  return <Navigate to={route} />;
};

const SignIn = () => {
  const location = useLocation();
  const [authContext] = useAuth();
  const roleId = authContext.currentUser?.role?.id;

  if (!authContext.currentUser) {
    return <LoginForm />;
  }

  let route;
  switch (roleId) {
    case DETAILER_CHECKER_ROLE_ID:
      route = "/detailer-checker-dashboard";
      break;
    case PROGRAMMER_ROLE_ID:
      route = "/programmer-dashboard";
      break;
    default:
      route = "/rfq/all";
      break;
  }
  return redirectTo(location, route, roleId);
};

export default SignIn;
